@if (multiple) {
  <p-fileupload
    #fileUpload
    (uploadHandler)="onUpload($event)"
    [customUpload]="true"
    [multiple]="true"
    [accept]="accept"
  >
    <ng-template #header> </ng-template>
    <ng-template #content let-files>
      @if (files?.length > 0) {
        <div
          class="upload-zone-static rounded-xl h-full flex flex-col"
          [class.dragging]="isDraggingOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="flex flex-col gap-2 p-4 flex-1 overflow-y-auto">
            @for (file of files; track file.name; let i = $index) {
              <div
                class="flex items-center gap-4 p-3 rounded-md border border-surface-200"
              >
                <i class="pi pi-file text-xl text-muted-color"></i>
                <span class="font-semibold flex-1 truncate">{{
                  file.name
                }}</span>
                <span class="text-sm text-muted-color">
                  {{ (file.size / (1024 * 1024)).toFixed(2) }} MB
                </span>
                <p-button
                  icon="pi pi-times"
                  (onClick)="removeFile(files, i)"
                  [text]="true"
                  [rounded]="true"
                  severity="danger"
                  size="small"
                  pTooltip="Remove file"
                />
              </div>
            }
          </div>
          <div class="flex gap-2 justify-end p-4 pt-0 shrink-0">
            <p-button
              icon="pi pi-plus"
              label="Add File"
              severity="secondary"
              (onClick)="fileUpload.choose()"
            />
            <p-button
              label="Upload"
              icon="pi pi-upload"
              (onClick)="fileUpload.upload()"
            />
          </div>
        </div>
      } @else {
        <div
          class="upload-zone flex flex-col items-center justify-center h-full w-full rounded-xl cursor-pointer"
          [class.dragging]="isDraggingOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileUpload.choose()"
        >
          <i
            class="pi pi-cloud-upload text-primary mb-4"
            style="font-size: 2rem"
          ></i>
          <p class="text-3xl font-semibold mb-2">Upload files here</p>
          <p class="text-lg text-muted-color">Click or Drag & Drop</p>
          <p class="text-md text-muted-color mt-2">
            Supported formats: {{ extensionsLabel }}
          </p>
        </div>
      }
    </ng-template>
  </p-fileupload>
} @else {
  <p-fileupload
    #fileUpload
    [customUpload]="true"
    [auto]="true"
    [accept]="accept"
    (uploadHandler)="onUpload($event)"
  >
    <ng-template #content>
      <div
        class="upload-zone flex flex-col items-center justify-center h-full w-full rounded-xl cursor-pointer"
        [class.dragging]="isDraggingOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileUpload.choose()"
      >
        <i class="pi pi-upload text-primary mb-4" style="font-size: 2rem"></i>
        <p class="text-3xl font-semibold mb-2">Upload a file here</p>
        <p class="text-lg text-muted-color">Click or Drag & Drop</p>
        <p class="text-md text-muted-color mt-2">
          Supported formats: {{ extensionsLabel }}
        </p>
      </div>
    </ng-template>
  </p-fileupload>
}
